const ROOT = '/api/site/v1/blogs';

export async function requestPublicBlog(path = '') {
  if (!/^(?:\?(?:limit=100)(?:&after=[A-Za-z0-9_-]{1,128})?|\/by-slug\/[a-z0-9]+(?:-[a-z0-9]+)*)?$/.test(path)) {
    throw new Error('Invalid blog API path.');
  }
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch(ROOT + path, {
      method: 'GET',
      credentials: 'omit',
      cache: 'no-store',
      redirect: 'error',
      referrerPolicy: 'no-referrer',
      signal: controller.signal,
    });
    const result = await response.json().catch(() => null);
    if (!response.ok || !result || !Object.prototype.hasOwnProperty.call(result, 'data')) {
      const error = new Error('Articles could not connect to the website. Please try again later.');
      error.status = response.status;
      error.code = result?.error?.code;
      throw error;
    }
    return result.data;
  } catch (error) {
    if (error.status) throw error;
    throw new Error('Articles could not connect to the website. Please try again later.');
  } finally {
    clearTimeout(timer);
  }
}
